export const companyName = 'Artapay By Artamedia'
export const appVersion = '0.1.1'
export const gatedUrlDocs = "https://red-satellite-138005.postman.co/workspace/ERP-Bridge-~be636d1b-95e0-41f2-8e90-cfda7ad66170/folder/15438133-63e75579-342b-4d06-8435-a271bfe29f00?action=share&creator=15438133"